import miles from '@utils/miles';

export default function formatRUT(value) {
  const rut = String(value).replace(/[^a-zA-Z0-9]/g, '');
  return rut.length > 1 ? `${miles(rut.slice(0, -1))}-${rut.slice(-1)}` : rut;
}
